import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductBadge } from '../../../ProductBadge'

type ProductCarouselVideoBadgeProps = {
  className: string
  onClick?: () => void
}

export const ProductCarouselVideoBadge: FC<ProductCarouselVideoBadgeProps> = ({
  className,
  onClick,
}) => (
  <ProductBadge
    className={clsx('bg-light-secondary-medium', className)}
    onClick={onClick}
    slots={{ root: 'button' }}
    type="button"
  >
    <span className="text-m">
      <FormattedMessage id="product.details.gallery.videobubble.video" />
    </span>
    <span className="text-xs">
      <FormattedMessage id="product.details.gallery.videobubble.play" />
    </span>
  </ProductBadge>
)
